import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import { CourseDetails,CourseList } from "API/apiRequest";

const initialState = {
  status: "idle",
  isLoggedIn: false,
  course_details_status: "idle",
  course_details_data: {},
  course_list_status: "idle",
  course_list_data: {},
  showCourseList: [],
  removeCourseList: [],
  searchedCourseName: "",
  // Incremented on every search submit so the list re-fetches even when the
  // searched term is unchanged (re-submitting an identical query).
  courseSearchTick: 0,
};
// course_data section
export const course_details = createAsyncThunk(
  "/CourseDetails",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const course_list = createAsyncThunk(
  "/CourseList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);



export const CourseSlice = createSlice({
  name: "course",
  initialState,
  reducers: {
    showSelectedList: (state, action) => {
      state.showCourseList = [...state.showCourseList, action.payload];
    },
    removeCourses: (state, action) => {
      state.showCourseList = action?.payload;
    },
    resetCourses: (state) => {
      state.showCourseList = [];
    },
    clearCourseListData: (state) => {
      state.course_list_data = initialState.course_list_data;
    },
    setSearchedCourseName: (state, action) => {
      state.searchedCourseName = action?.payload;
    },
    bumpCourseSearchTick: (state) => {
      state.courseSearchTick += 1;
    },
    clearSearchedCourseName: (state,) => {
      state.searchedCourseName = initialState.searchedCourseName;
    },
    clearCourseDetailsData:(state=>{
      state.course_details_data=initialState.course_details_data
    })
  },
  extraReducers: (builder) => {
    builder
      // course_details section
      .addCase(course_details.pending, (state) => {
        state.course_details_status = "loading";
      })
      .addCase(course_details.fulfilled, (state, { payload }) => {
        state.course_details_status = "idle";
        state.course_details_data = payload?.data;
        // localStorage.setItem("profile_data", JSON.stringify(payload?.data));
      })
      .addCase(course_details.rejected, (state) => {
        state.course_details_status = "idle";
      })

      // course list
      .addCase(course_list.pending, (state) => {
        state.course_list_status = "loading";
      })
      .addCase(course_list.fulfilled, (state, { payload }) => {
        state.course_list_status = "idle";
        state.course_list_data = payload?.data;
      })
      .addCase(course_list.rejected, (state) => {
        state.course_list_status = "idle";
      })
    // course list

  },
});

export const {
  showSelectedList,
  removeCourses,
  resetCourses,
  clearCourseListData,
  setSearchedCourseName,
  bumpCourseSearchTick,
  clearSearchedCourseName,
  clearCourseDetailsData
} = CourseSlice.actions;

export default CourseSlice.reducer;
